// Function to save cart contents to URL
function saveCartToURL(targetDomain) {
  console.log('Saving cart to URL for domain switch...');

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const cartItems = cart.items.map((item) => ({
        id: item.variant_id,
        quantity: item.quantity,
      }));
      const cartData = encodeURIComponent(JSON.stringify(cartItems));
      console.log('Cart items saved:', cartItems);

      // Redirect to the target domain with cart data as a URL parameter
      window.location.href = `${targetDomain}/?cartData=${cartData}`;
    })
    .catch((error) => console.error('Error saving cart to URL:', error));
}

// Function to clear current cart
function clearCart() {
  console.log('Clearing the cart...');
  return fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then(() => console.log('Cart cleared successfully'))
    .catch((error) => console.error('Error clearing the cart:', error));
}

// Function to restore cart from URL parameter
function restoreCartFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const cartData = urlParams.get('cartData');

  if (cartData) {
    const items = JSON.parse(decodeURIComponent(cartData));
    console.log('Restoring cart with items:', items);

    clearCart().then(() => {
      console.log('Adding all items to cart in a single request:', items);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      })
        .then((response) => response.json())
        .then((data) => console.log('All items added successfully:', data))
        .catch((error) => console.error('Error adding items to cart:', error));

      // Clear the cartData parameter from the URL
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    });
  } else {
    console.log('No cart data found in URL');
  }
}

// Function to handle domain switching with cart transfer
function switchDomainWithCart(targetDomain) {
  console.log(`Switching to ${targetDomain} and saving cart data...`);
  saveCartToURL(targetDomain);
}

// Restore cart on page load if cart data is in the URL
document.addEventListener('DOMContentLoaded', () => {
  restoreCartFromURL();
});
